export default __webpack_public_path__ + "static/media/achievement-1.5010e244.jpg";